"use client"

import {useEffect} from "react";
import {useCompanyId} from "@/hooks/use-company-id";

export const LastOpenedCompanyKey = "lastOpenedCompany"

/**
 * A special component serving to remember last selected company in the local store. Allows to re-open
 * last viewed company on login.
 */
export function RememberCompany() {
    const { companyId } = useCompanyId()
    useEffect(() => {
        if (companyId === undefined) {
            return
        }
        const newId = companyId.toString()
        if (localStorage.getItem(LastOpenedCompanyKey) === newId) {
            return
        }
        localStorage.setItem(LastOpenedCompanyKey, newId)
    }, [companyId]);
    return <div />
}